import { useAuthenticator } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { LOGIN_PATH } from 'src/common/constants';
import 'src/styles/apply-tailwind.css';

const AuthRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut } = useAuthenticator((context) => [context.user]);

  useEffect(() => {
    Auth.currentAuthenticatedUser().catch(() => {
      signOut();
      navigate(LOGIN_PATH, { replace: true, state: { from: location } });
    });
  }, [location, navigate, signOut]);

  return <Outlet />;
};

export default AuthRoute;
